<template>
  <v-card class="gallery-item-card" outlined>
    <v-row no-gutters>
      <!-- Left Column (approx. 40% width): Text & Details -->
      <v-col cols="12" md="5" class="pa-4 left-column">
        <v-card-title class="gallery-title">{{
          galleryItem.title
        }}</v-card-title>
        <!-- Full, wrapping description -->
        <v-card-subtitle class="mb-3 description">
          {{ galleryItem.description }}
        </v-card-subtitle>
        <v-card-text>
          <v-row rows="12">
            <v-col cols="12">
              <v-divider class="mb-3"></v-divider>
            </v-col>

            <v-col cols="4">
              <div class="detail-row">
                <span class="detail-label">Venue:</span>
                <span class="detail-value">{{ galleryItem.venueType }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Value:</span>
                <span class="detail-value">{{
                  formatNumber(galleryItem.value)
                }}</span>
              </div>
              <div class="detail-row">
                <v-icon small class="mr-1">mdi-shower</v-icon>
                <span class="detail-label">Bathrooms:</span>
                <span class="detail-value">{{
                  galleryItem.bathroomCount
                }}</span>
              </div>
              <div class="detail-row">
                <v-icon small class="mr-1">mdi-bed</v-icon>
                <span class="detail-label">Bedrooms:</span>
                <span class="detail-value">{{ galleryItem.bedroomCount }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Lot Size:</span>
                <span class="detail-value">{{ galleryItem.lotSize }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">File Size:</span>
                <span class="detail-value">{{ galleryItem.fileSize }}</span>
              </div>
              <div class="detail-row" v-if="galleryItem.fileUrl">
                <span class="detail-value">
                  <a :href="galleryItem.fileUrl" target="_blank">
                    Download Here
                  </a>
                </span>
              </div>
            </v-col>
            <v-col cols="8">
              <!-- Packs with icons -->
              <div
                v-if="galleryItem.packs && galleryItem.packs.length"
                class="mt-3"
              >
                <div class="detail-label mb-1"><strong>Packs:</strong></div>
                <v-row dense>
                  <v-col
                    v-for="pack in galleryItem.packs"
                    :key="pack.id"
                    cols="auto"
                    class="d-flex align-center pack-item"
                  >
                    <PackIcon
                      :icon="getImage(pack.iconName)"
                      :pack="pack.name"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-col>

      <!-- Right Column (approx. 60% width): Flexible Images Grid -->
      <v-col
        cols="12"
        md="7"
        class="pa-4 right-column"
        v-if="galleryItem.images"
      >
        <div v-if="galleryItem.images.length > 1">
          <v-carousel
            cycle
            height="100%"
            hide-delimiters
            hide-controls
            show-arrows-on-hover
          >
            <v-carousel-item
              v-for="(img, index) in galleryItem.images"
              :key="index"
            >
              <!-- Center container -->
              <v-sheet
                height="100%"
                style="background-color: red; margin-top: 35px"
                class="carousel-container"
              >
                <v-card class="mx-auto my-4 gallery-hover-card carousel-inner">
                  <v-img
                    :src="getImage(img)"
                    class="gallery-thumbnail carousel-image"
                    contain
                  ></v-img>
                </v-card>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </div>

        <div v-else>
          <v-sheet height="100%" style="margin-top: 35px" class="gallery-frame">
            <v-img
              :src="getImage(galleryItem.images[0])"
              class="gallery-image"
            ></v-img>
          </v-sheet>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { WS } from "@/services/WS";
import PackIcon from "@/icons/PackIcon.vue";
export default {
  name: "GalleryItemCard",
  components: {
    PackIcon,
  },
  props: {
    // Expected galleryItem properties:
    // id, title, description, venueType, value, bathroomCount, bedroomCount,
    // lotSize, fileSize, fileUrl, packs, images.
    galleryItem: {
      type: Object,
      required: true,
    },
  },
  methods: {
    // Returns the full URL for an image based on its filename.
    getImage(filename) {
      return WS.getImage(filename);
    },
    // Formats a number with comma separators and up to two decimals (no currency symbol).
    formatNumber(value) {
      const num = Number(value) || 0;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        maximumFractionDigits: 2,
      }).format(num);
    },
  },
};
</script>
<style scoped>
.gallery-hover-card {
  border-color: transparent;
  background-color: rgba(217, 217, 217, 0.2);
  font-weight: bold;
  width: 80%; /* optional if you want to constrain the card width */
  padding: 40;
}

.gallery-frame {
  align-items: center;
  background-color: rgba(217, 217, 217, 0.9);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.gallery-image {
  border-radius: 20px;

  font-weight: bold;
  width: 80%;
  padding: 0;
}

/* Flex container to center the image horizontally and vertically */
.carousel-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-inner {
  /* This ensures the card itself is also centered if needed */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Make the image 80% of its parent, keep it centered */
.carousel-image {
  max-width: 80%;
  margin: 0 auto;
  object-fit: cover; /* or contain if you want to see the entire image */
}
</style>
